import React from "react";
import PropTypes from "prop-types";
import {
  AppStatus,
  TestResultList,
  VersionsDisplay,
  DnsIpCompare,
  RecordStatus,
  LiveStatus,
  SpeedTest,
  TrackingCameraInfo
} from "../index";
import {
  checkAppStatus,
  checkCamerasInternalIps,
  checkCamerasRtspPorts,
  checkCommunicationFile,
  checkDnsIpCompare,
  checkExternalPorts,
  checkLive,
  checkOutsideAccess,
  checkRecord,
  checkSpeedtest,
  checkSshConnection,
  checkVersions,
  checkTrackingCamera,
  checkDockerImages,
  checkScoreCamera,
  checkDisplayDongleExist
} from "../../utils/testing-api";
import I18N from "../../I18N";
import "./siteTestsGrid.scss";
import ScoreCameraInfo from "../ScoreCameraInfo/ScoreCameraInfo";

const SiteTestsGrid = ({ testsResult, onReTestClick }) => {
  const {
    appStatus,
    camerasRtspPorts,
    camerasInternalIps,
    externalPorts,
    communicationFile,
    versions,
    dnsIpCompare,
    outSideAccess,
    sshConnection,
    record,
    live,
    speedtest,
    trackingCamera,
    dockerImages,
    scoreCamera,
    isDongleExist
  } = testsResult;
  const { isTracking } = trackingCamera || {};
  const { hasScoreCamera } = scoreCamera;
  return (
    <div className="site-tests-grid">
      <div style={{ display: "flex" }}>
        <AppStatus
          appStatus={appStatus}
          handleReTest={() => {
            onReTestClick(checkAppStatus, "appStatus");
          }}
        />
        {isTracking && (
          <TrackingCameraInfo
            cameraInfo={trackingCamera}
            handleReTest={() => {
              onReTestClick(checkTrackingCamera, "trackingCamera");
            }}
          />
        )}
        {hasScoreCamera && (
          <ScoreCameraInfo
            cameraInfo={scoreCamera}
            handleReTest={() => {
              onReTestClick(checkScoreCamera, "scoreCamera");
            }}
          />
        )}
      </div>
      <TestResultList
        results={sshConnection}
        title={I18N.t("SSH_CONNECTION")}
        handleReTest={() => {
          onReTestClick(checkSshConnection, "sshConnection");
        }}
      />

      {isTracking && (
        <TestResultList
          results={isDongleExist}
          title={I18N.t("SITE_DONGLE")}
          handleReTest={() => {
            onReTestClick(checkDisplayDongleExist, "isDongleExist");
          }}
        />
      )}

      <DnsIpCompare
        results={dnsIpCompare}
        handleReTest={() => {
          onReTestClick(checkDnsIpCompare, "dnsIpCompare");
        }}
      />
        
      <TestResultList
        results={outSideAccess}
        title={I18N.t("OUTSIDE_ACCESS")}
        handleReTest={() => {
          onReTestClick(checkOutsideAccess, "outSideAccess");
        }}
      />

      <TestResultList
        results={camerasRtspPorts}
        title={I18N.t("RTSP")}
        firstColTitle={`${I18N.t("IP")}:${I18N.t("PORT")}`}
        handleReTest={() => {
          onReTestClick(checkCamerasRtspPorts, "camerasRtspPorts");
        }}
      />
      <TestResultList
        results={camerasInternalIps}
        title={I18N.t("INTERNAL_IPS")}
        firstColTitle={I18N.t("IP")}
        handleReTest={() => {
          onReTestClick(checkCamerasInternalIps, "camerasInternalIps");
        }}
      />

      <TestResultList
        results={externalPorts}
        title={I18N.t("EXTERNAL_PORTS")}
        firstColTitle={I18N.t("PORT")}
        handleReTest={() => {
          onReTestClick(checkExternalPorts, "externalPorts");
        }}
      />

      <VersionsDisplay
        versions={versions}
        handleReTest={() => {
          onReTestClick(checkVersions, "versions");
        }}
      />
      <TestResultList
        results={communicationFile}
        title={I18N.t("COMMUNICATION_FILE")}
        handleReTest={() => {
          onReTestClick(checkCommunicationFile, "communicationFile");
        }}
      />
      <TestResultList
        results={dockerImages}
        title={I18N.t("DOCKER_IMAGES")}
        firstColTitle={I18N.t("DOCKER_NAME")}
        hasStatus={false}
        handleReTest={() => {
          onReTestClick(checkDockerImages, "dockerImages");
        }}
      />
      <RecordStatus
        result={record}
        handleReTest={() => {
          onReTestClick(checkRecord, "record");
        }}
      />
      <LiveStatus
        liveStatus={live}
        handleReTest={() => {
          onReTestClick(checkLive, "live");
        }}
      />
      <SpeedTest
        result={speedtest}
        handleReTest={() => {
          onReTestClick(checkSpeedtest, "speedtest");
        }}
      />
    </div>
  );
};

SiteTestsGrid.propTypes = {
  testsResult: PropTypes.object.isRequired,
  onReTestClick: PropTypes.func.isRequired
};

export default SiteTestsGrid;
